import React from 'react'

import { Field } from 'formik'

import { Table, Col, Row, Form } from '_zari/core'

import * as AsientosContablesService from 'services/asientosContables.service'

const CancelacionSection = ({ idSocio, iValue, values, setValues, handleChange, vOrigen }) => {
  const [filas, setFilas] = React.useState([])

  React.useEffect(() => {
    if (idSocio === '') {
      setFilas([])
    } else {
      AsientosContablesService.getPendientesxSocioxOrigen(idSocio, vOrigen).then(({ data }) => {
        setFilas(data)
      })
    }
  }, [idSocio, vOrigen])

  const onChange = React.useCallback(
    e => {
      handleChange(e)

      const seleccionada = filas.find(x => x._id === e.target.value)
      if (seleccionada) {
        values.importeHaber = seleccionada.monto
        values.tipoDocumento = seleccionada.tipoDocumento
        values.serieDocumento = seleccionada.serieDocumento
        values.numeroDocumento = seleccionada.numeroDocumento
        values.fechaDocumento = seleccionada.fechaEmision
        values.fechaVencimiento = seleccionada.fechaVencimiento
        values._idCancelacion = e.target.value
        values.dh = 'HAB'

        setValues(values)
      }
    },
    [handleChange, filas, values, setValues]
  )

  return (
    <Row>
      <Col md={12}>
        <Table
          headRows={[
            { label: 'FEC. EMI' },
            { label: 'FEC. VEN' },
            { label: 'TIPO' },
            { label: 'SERIE' },
            { label: 'DOCUMENTO' },
            { label: 'MONEDA' },
            { label: 'SALDO' },
            { label: '' }
          ]}
          filas={filas}
          maxRowsShown={10}
          rowTemplate={(row, k) => (
            <Table.Row key={k}>
              <Table.Cell>{row.fechaEmision || '--'}</Table.Cell>
              <Table.Cell>{row.fechaVencimiento || '--'}</Table.Cell>
              <Table.Cell>{row.tipoDocumento || '--'}</Table.Cell>
              <Table.Cell>{row.serieDocumento || '--'}</Table.Cell>
              <Table.Cell>{row.numeroDocumento || '--'}</Table.Cell>
              <Table.Cell>{row.moneda || '--'}</Table.Cell>
              <Table.Cell>{row.monto || '--'}</Table.Cell>
              <Table.Cell>
                <Field name='_idCancelacion'>
                  {({ field }) => (
                    <Form.Radio
                      {...field}
                      id={`radio-documento-cancelacion-${row._id}`}
                      value={row._id}
                      label='-'
                      checked={iValue === row._id}
                      onChange={onChange}
                    />
                  )}
                </Field>
              </Table.Cell>
            </Table.Row>
          )}
        />
      </Col>
    </Row>
  )
}

export default React.memo(CancelacionSection)
